import { ca } from '@cian/analytics';

export const trackPayByCardModalOpen = (label, category) => {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'not_enough_money_popup_open',
    label,
  });
};

export const trackRefillByCardModalOpen = (label, category) => {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'enough_money_popup_open',
    label,
  });
};
